import { render } from "./AddedGoods.vue?vue&type=template&id=4bad858a"
import script from "./AddedGoods.vue?vue&type=script&lang=js"
export * from "./AddedGoods.vue?vue&type=script&lang=js"

import "./AddedGoods.vue?vue&type=style&index=0&id=4bad858a&lang=scss"
script.render = render

export default script